module.exports = __webpack_public_path__ + "img/social_image_tiktok.2ffa6de.svg";